const ModalEnum = {
  MAP: 'map',
  NEW_REPORT: 'newReport',
  ACCOUNT: 'account',
  CUSTOMERS: 'customers',
  USERS: 'users',
  GROUP: 'group',
  GEOFENCE: 'geofence',
  SINISTER: 'sinister',
  DEVICE: 'device',
  DRIVER: 'driver',
  NOTIFICATION: 'notification',
  CALENDAR: 'calendar',
  MAINTENANCE: 'maintenance',
  SERVER: 'server',
  COMPANY_CONFIG: 'companyConfig',
  COMMAND: 'command',
  NEW_SINISTER: 'newSinister',
  INTEGRATION: 'integration',
  INTEGRATIONCONFIG: 'integrationconfig',
  REPORT_JOBS: 'reportjobs',
  BILLING: 'billing',
};

export default ModalEnum;
